// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__PoEjk","slideUp":"Overlay_slideUp__tfmoD","slideDown":"Overlay_slideDown__WSmFw"};